export class TjipClipboardService {
  public static getText(event: Event) {
    let result = '';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const w: any = window;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ev = event as any;
    const data = ev && ev.clipboardData;
    if (data && data.getData) {
      result = data.getData('text/plain');
    } else if (w.clipboardData && w.clipboardData.getData) {
      // IE
      result = w.clipboardData.getData('Text');
    } else if (ev && ev.originalEvent) {
      result = TjipClipboardService.getText(ev.originalEvent);
    }
    return result;
  }
}
